import { c as _c } from "react/compiler-runtime";
import Icon from './empty.icon.svg';
import css from './empty.module.scss';
export function Empty() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={css.empty}><Icon /><span>No items</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}